import { g_nullNcode } from "../../../common/constants/NcodeConstants";
import { MappingStorage } from "../../../common/mapper/MappingStorage";
import { cloneObj } from "../../../common/util/functions";
import { g_defaultPrintOption } from "./DefaultOption";
/**
 * @param printOption - in/out
 * @param pdf - in
 */
export const setDefaultPrintOption = (pdf, printOption = undefined) => {
    if (printOption === undefined)
        printOption = cloneObj(g_defaultPrintOption);
    let pdfToNcodeMap = undefined;
    if (pdf) {
        // 기본 값으로는 모든 페이지를 인쇄하도록
        printOption.fingerprint = pdf.fingerprint;
        printOption.docNumPages = pdf.numPages;
        printOption.targetPages = Array.from({ length: printOption.docNumPages }, (_, i) => i + 1);
        // 이전에 매핑되었던 값을 찾아서 기본값으로 설정해 둔다
        const msi = MappingStorage.getInstance();
        pdfToNcodeMap = msi.getAssociatedMappingInfo(printOption.fingerprint, printOption.pagesPerSheet, printOption.docNumPages);
        const partOption = msi.getCodePrintInfo(printOption, undefined);
        for (const key in partOption)
            printOption[key] = partOption[key];
    }
    else {
        printOption.needToIssuePrintCode = true;
        printOption.forceToUpdateBaseCode = true;
        printOption.printPageInfo = Object.assign({}, g_nullNcode);
        printOption.basePageInfo = Object.assign({}, g_nullNcode);
    }
    return { pdfToNcodeMap, printOption };
};
//# sourceMappingURL=PrintOptions.js.map